export default function buildPaginationArray(pageNumber, currentPage, spacing) {
  const pageArray = [];

  const startingPosition = Math.max(currentPage - spacing, 1);
  const endPosition = Math.min(currentPage + spacing, pageNumber);

  for (let i = startingPosition; i <= endPosition; i++) {
    pageArray.push(i);
  }

  if (currentPage - spacing > 1) {
    appendFirstPages(pageArray);
  }

  if (currentPage + spacing < pageNumber) {
    appendLastPages(pageArray, pageNumber);
  }

  return pageArray;
}

function appendFirstPages(array) {
  const initialValue = array[0];

  if (initialValue - 1 > 1) {
    array.unshift('...');
  }

  array.unshift(1);
}

function appendLastPages(array, lastPageNumber) {
  if (array[array.length - 1] + 1 < lastPageNumber) {
    array.push('...');
  }

  array.push(lastPageNumber);
}
